import React from "react";

const CookieBanner = ({ onAccept }) => {
  const handleReadMore = () => {
    window.open("https://hourlee.in/cookie-policy", "_blank");
  };

  return (
    <div className="cookie-banner">
      <p>
        We use cookies to improve your experience, analyze traffic, and serve
        personalized content. By continuing to use Hourlee, you agree to our use
        of cookies.
      </p>

      <div className="cookie-actions">
        <button
          className="normalbtn"
          style={{
            backgroundColor: "#270b79",
            border: "4px solid #270b79",
            marginLeft: "4px",
          }}
          onClick={handleReadMore}
        >
          Learn More
        </button>
        <button className="normalbtn" onClick={onAccept}>
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
